import { IModalWizardPageDataError } from '../types/modal/modal-wizard-page-data-error.interface';

export const getFieldPageDataErrors = (pageDataErrors: null | undefined | IModalWizardPageDataError[], fieldName: string): false | IModalWizardPageDataError[] => {
  const result = (pageDataErrors ?? []).filter((pageDataError) => pageDataError.fieldName === fieldName);
  if (result.length) {
    return result;
  }
  return false;
};
